module.exports = __webpack_public_path__ + "img/555c514.png";